import React, {useState} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import ShowLogicTree from './showLogicTree/ShowLogicTree'
import {calculteScores, setNodesData, loadOptions, setTreeContextById} from '../redux/actions'
import {connect} from 'react-redux'
import {resortOptions, setControlOptionDisplay, uploadTreeContext} from '../redux/actions'
import {RUNNING, SUCSSES, ERROR} from '../redux/actions';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import HelpButton, {HELP_TREE} from './help/HelpButton';

export const UPLOD_CONTEXT_PROCESS = "UPLOD_CONTEXT_PROCESS"
export const DOWNLOAD_CONTEXT_PROCESS = "DOWNLOAD_CONTEXT_PROCESS"

const  OptionsFragmentControler = (props) => {
    const uploadContextProcessState = props.uploadContextProcessState
    return (
      <div className="container sticky mx-auto user-prefernces">
        <div className="row sticky  ">
          <div className="col  h-100">
                <div className="row justify-content-start">
                  <div className="col-auto px-0 mx-0 upperPrefBar">
                    <span className={"title options-controler-title"}>
                      <i class="fas fa-sliders-h" style={{WebkitTextStroke: "1px black", color:"lightblue", textAlign:"left"}}></i>
                      {" Set your preferences"}</span>
                      <HelpButton type={HELP_TREE}/>

                  </div>
                </div>
              <div className="row justify-content-start">
                <span className="col-auto px-0 mx-0 text-muted branches_discrption" style={{textAlign:"left"}}>
                    { "Press titles to costimaze grading & read more information." }
                </span>
              </div>
                {<div className="row justify-content-start ">
                  {/*<ButtonGroup variant="text" color="primary"   aria-label=" primary button group">
                      <Tooltip title={<React.Fragment>
                          <p>{"Restart to defualt values"}</p></React.Fragment>} arrow>
                        <Button className=" col-auto" onClick={() => {console.log("pressed 1");props.setTreeContextById(1, DOWNLOAD_CONTEXT_PROCESS)}}>
                          <span style={{fontSize:"10px"}}>{"Defualt"}</span>
                        </Button>
                      </Tooltip>
                      <Tooltip title={<React.Fragment>
                          <h5>{"Tal:"}</h5>
                          <p>{"Wants to get the phone with the best Reviews for the cheapest Price"}</p></React.Fragment>} arrow>
                        <Button className=" col-auto" onClick={() => {console.log("pressed 2");props.setTreeContextById(2, DOWNLOAD_CONTEXT_PROCESS)}}>
                          <span style={{fontSize:"10px"}}>{"Tal"}</span>
                        </Button>
                      </Tooltip>
                      <Tooltip title={<React.Fragment>
                          <h5>{"Yael:"}</h5>
                          <p> {"Yael wants a great phone and is willing to invest more money.\n She likes to travel, and wants a great back camera to take picteres.\n She also wants a phone with a strong CPU on which she could do some work."}</p>
                    </React.Fragment>} arrow>
                        <Button className=" col-auto" onClick={() => {console.log("pressed 3");props.setTreeContextById(3, DOWNLOAD_CONTEXT_PROCESS)}}>
                        <span style={{fontSize:"10px"}}>{"Yael"}</span>
                        </Button>
                      </Tooltip>
                    </ButtonGroup>*/}
                </div>}
                <div className="row h-100">
                  <div className="col">
                    <ShowLogicTree
                      treeId={props.treeId}
                      onWightChange={(nodesData) => {
                        console.log("there was a wight change");
                        console.log(nodesData);
                        loadOptions({category:"phones",
                          treeId:4,
                        }, {})}
                      }/>
                  </div>
                </div>
                <div className="row lowerPrefBar">
                  <button disabled={(!props.isAuthenticated) ||
                      (uploadContextProcessState === RUNNING) ||
                      (uploadContextProcessState === SUCSSES)}
                      className={uploadContextProcessState !== ERROR?"btn btn-primary":"btn btn-warning"}
                      onClick={()=>(props.uploadTreeContext(props.treeContext, UPLOD_CONTEXT_PROCESS))}>
                      {(uploadContextProcessState !== RUNNING &&
                        uploadContextProcessState !== SUCSSES &&
                        uploadContextProcessState !== ERROR) && <i className="far fa-save"></i>}
                        {uploadContextProcessState === RUNNING && <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                        {uploadContextProcessState === SUCSSES && <i class="far fa-check-circle"></i>}
                        {uploadContextProcessState === ERROR && <i class="fas fa-redo-alt"></i>}
                          {(!props.isAuthenticated) &&
                            <div>{" login to save"}</div>
                          }
                    </button>
                </div>
          </div>
        </div>
      </div>
    );
  }

const mapStateToProps = (state) => ({
  /*tree: state.logicTree,
  scores: state.logicTree._scores,*/
  isAuthenticated: state.auth.isAuthenticated,
  optionMetaData: state.options.optionMetaData,
  options: state.options.optionsChosen,
  controlFormat: state.displayState.controlOptionsDisplay,
  treeContext: state.nodesData,
  uploadContextProcessState: state.processManager.processes[UPLOD_CONTEXT_PROCESS]
})

const actionsCreators = {
  setTreeContextById:setTreeContextById,
  calculteScores: calculteScores,
  resortOptions: resortOptions,
  loadOptions:loadOptions,
  setControlOptionDisplay:setControlOptionDisplay,
  uploadTreeContext:uploadTreeContext,
}
export default connect(mapStateToProps, actionsCreators)(OptionsFragmentControler)
